import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-button',
  imports: [CommonModule],
  template: `
    <button
      (click)="clicked()"
      class="flex justify-center gap-1.5 text-white px-2.5 sm:px-3 py-1.5 sm:py-2 text-[12px] sm:text-[12px] rounded-md w-full uppercase tracking-wide cursor-pointer items-center text-nowrap font-semibold transition-all duration-150 hover:opacity-90 active:scale-[0.98]"
      [ngClass]="{
        'bg-[#043B22]/50 cursor-wait': loading,
        'bg-[#CED4DA] !cursor-not-allowed text-[#616161]': disabled,
        'bg-[#043B22]': !disabled,
        class
      }"
      [disabled]="disabled"
    >
      <svg *ngIf="loading" class="animate-spin h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      <ng-content></ng-content>
      {{ text }}
    </button>
  `
})
export class ButtonComponent {
  @Input() text: string = '';
  @Input() class: string = '';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() onClick: Function = () => {};

  isClicked: boolean = false;

  clicked = () => {
    this.isClicked = true;
    this.onClick();
    setTimeout(() => {
      this.isClicked = false;
    }, 100);
  };
}
